// This file is protected and will be overwritten by the @aab/cli
import AabNotification from './AabNotification';

customElements.define('aab-notification', AabNotification);
